import zxcvbn from 'zxcvbn'
import { i18n } from '@/i18n'

export function getPasswordErrors(password = '') {
  // Translated when asked, so the list follows the reader's language.
  const t = (rule) => i18n.global.t(`auth.password.rules.${rule}`)
  const errors = []
  if (password.length < 12)    errors.push(t('minLength'))
  if (!/[A-Z]/.test(password)) errors.push(t('uppercase'))
  if (!/[a-z]/.test(password)) errors.push(t('lowercase'))
  if (!/\d/.test(password))    errors.push(t('digit'))
  if (!/[\W_]/.test(password)) errors.push(t('symbol'))
  return errors
}

// require both your regex rules AND a zxcvbn score ≥ 3
export function isPasswordStrong(password = '') {
  const passesRules = getPasswordErrors(password).length === 0
  const entropyOk    = zxcvbn(password).score >= 3   // 0–4
  return passesRules && entropyOk
}